import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CacheService } from '../../_service/cache.service';
import { ServiceAdapterService } from '../../_service/service-adapter.service';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ServiceConfigService } from '../../../app/_service/service-config.service';
import { AppConfigService } from '../../../app/_service/app-config.service';
import { HttpResponse } from '../../_interface/http-response.interface';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  homePageJson = [
    { "icon": "./assets/icons/dashboardblue.svg", "text": "DASHBOARD", "link": "/dashboard" },
    { "icon": "./assets/icons/trends.svg", "text": "TRENDS", "link": "/trends/enterprise/timeofday" },
    { "icon": "./assets/icons/utilityBreakuphome.svg", "text": "BREAKUP", "link": "/breakup/enterprise/utility" },
    { "icon": "./assets/icons/alertsblue.svg", "text": "ALERTS", "link": "/alerts/alertkpi" },
    { "icon": "./assets/icons/kpiBlue.svg", "text": "KPI", "link": "/kpi/plant/plantkpi" },
    { "icon": "./assets/icons/assetViewBlue.svg", "text": "ASSET VIEW", "link": "assetview/overview" },
  ]
  userName = sessionStorage.getItem('userName');
  isUserAuthorised = false;
  alertMessage = '';
  @ViewChild("content1") modalContent: TemplateRef<any>;
  loadingFlag = false;
  azureAuthFlag: any;
  constructor(private router: Router, private cacheService: CacheService, private msalService: MsalService,
    private serviceAdapterService: ServiceAdapterService, private modalService: NgbModal, private appConfigService: AppConfigService, private serviceConfigService: ServiceConfigService) {
    let reqJson = { "userID": sessionStorage.getItem('userId') };
    this.loadingFlag = true;
    const token = sessionStorage.getItem('accessToken');
    if (token) {
  this.isUserAuthorised = true;
  Promise.resolve().then(() => (this.loadingFlag = false)); // microtask flush to ensure UI updates
  return; // stop here; don't call backend
}
    if (!token) {
      setTimeout(() => this.serviceAdapterService.backendServiceCall("getUserAuthorization", reqJson).subscribe((resData: any) => {
        this.loadingFlag = false;
        if (resData['message'] == 'Valid User') {
          this.isUserAuthorised = true;
          const customToken = resData?.data?.accessToken;
          if (customToken) {
            sessionStorage.setItem('customToken', customToken)
          }
        }
        else {
          this.isUserAuthorised = false;
          this.alertMessage = 'User not registered to access this application. Please contact Admin for registration';
          this.modalService.open(this.modalContent);
        }
      },
        (err) => {
          this.isUserAuthorised = false;
          this.loadingFlag = false
        },
        () => {
          this.loadingFlag = false;
        }), 200);
    }
    else {
      console.log('error');
    }
  }

  ngOnInit(): void {
    this.appConfigService.load();
    this.serviceConfigService.load();

  };
  onClickCard(event, link) {
    if (this.isUserAuthorised) {
      this.router.navigateByUrl('/' + link);
    }
    else {
      this.alertMessage = 'User not registered to access this application. Please contact Admin for registration'
      this.modalService.open(this.modalContent);
    }
  }
  onClickLogout() {
    var appConfig = JSON.parse(sessionStorage.getItem('appconfig') || '{}');
    let azureAuthFlag = appConfig['azureAuthFlag'];
    if (azureAuthFlag) {
      this.cacheService.clearCache();
      this.msalService.logout();
      this.onsessionStorageRemoveMethod();
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("userName");
    } else {
      this.router.navigateByUrl("login");
      this.onsessionStorageRemoveMethod();
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("userName");

    }
  }
  sessionStorageArr = ['serviceconfig', 'userId', 'appconfig', 'selectedValue', "userName", "routerconfig"];
  onsessionStorageRemoveMethod() {
    let keyArr = Object.keys(sessionStorage);
    keyArr.forEach(key => {
      if (this.sessionStorageArr.indexOf(key) == -1)
        sessionStorage.removeItem(key);
    });
  }

  onClickHome() {
    this.router.navigateByUrl('alerts')
  }

  onClickAlert() {
    this.router.navigateByUrl('alerts')
  }
}